import {
    Alert,
    ArrowRightIcon,
    Avatar,
    Dropdown,
    ExclamationCircleIcon,
    Flex,
    Input,
    InputLabel,
    Skeleton,
    Text,
} from "@fluentui/react-northstar";
import React from "react";
import { CustomBadge } from "../../../../components/Badge";
import { Controller, useFormContext } from "react-hook-form";
import { TYPES_STATUS_ALERT_MESSAGE } from "../../constants/types.status";
import moment from "moment";
import { ErrorMessage } from "../../../../common/styles";

const DialogPrepareOffboardingContent = ({
    selected_user = null,
    list_offboarding_users = [],
    list_status_types = [],
    is_loading_status = false,
}) => {
    const {
        formState: { errors },
        control,
        getValues,
        watch,
    } = useFormContext();

    const minToday = moment().format("YYYY-MM-DD");
    const show_section_attribution = list_status_types?.length > 0;
    const alert_message = TYPES_STATUS_ALERT_MESSAGE[watch("new_status")?.id];

    return (
        <Flex column gap="gap.large">
            <Flex column gap="gap.medium" fill>
                {/* dropdown users */}
                <div style={{ width: "100%" }}>
                    <Controller
                        control={control}
                        name="user_id"
                        rules={{
                            required: {
                                value: true,
                                message: "Ce champ est obligatoire",
                            },
                        }}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <Dropdown
                                    items={list_offboarding_users}
                                    itemToString={(item) =>
                                        item ? item.name : ""
                                    }
                                    renderItem={(ItemComponent, props) => {
                                        if (!props) return null;

                                        const user = props;
                                        return (
                                            <ItemComponent
                                                {...props}
                                                header={
                                                    <Flex
                                                        vAlign="center"
                                                        gap="gap.small"
                                                    >
                                                        <Avatar
                                                            image={user.avatar}
                                                            name={user.name}
                                                        />
                                                        <Flex column>
                                                            <Text
                                                                content={
                                                                    user.name
                                                                }
                                                            />
                                                            <Text
                                                                content={
                                                                    user.content
                                                                }
                                                            />
                                                        </Flex>
                                                    </Flex>
                                                }
                                                content=""
                                            />
                                        );
                                    }}
                                    onChange={(e, i) => {
                                        return onChange(i.value);
                                    }}
                                    value={list_offboarding_users.find(
                                        (user) => user.id === value?.id
                                    )}
                                    placeholder="Recherchez un collaborateur..."
                                    name={name}
                                    ref={ref}
                                    checkable
                                    search
                                    fluid
                                />
                            );
                        }}
                    />
                </div>
                {/* status + types dropdown */}
                {getValues("user_id") && (
                    <>
                        {/* status */}
                        <Flex column>
                            <InputLabel content="Quel autre statut souhaitez-vous attribuer au collaborateur ?" />
                            <Flex vAlign="center" gap="gap.large">
                                {/* badge */}
                                <CustomBadge
                                    bg="#E8EBFA"
                                    color="#4F52B2"
                                    label={<b>{selected_user?.status}</b>}
                                    rectangular
                                    styles={{
                                        width: "106px",
                                        justifyContent: "center",
                                    }}
                                />
                                <ArrowRightIcon />
                                <Flex fill>
                                    <div style={{ width: "100%" }}>
                                        {is_loading_status ? (
                                            <Skeleton animation="pulse">
                                                <Skeleton.Input
                                                    width={"100%"}
                                                    height={24}
                                                    fluid
                                                />
                                            </Skeleton>
                                        ) : (
                                            <Controller
                                                control={control}
                                                name="new_status"
                                                render={({
                                                    field: {
                                                        onChange,
                                                        value,
                                                        name,
                                                        ref,
                                                    },
                                                }) => {
                                                    const indexOfDefaultValue =
                                                        list_status_types.findIndex(
                                                            (l) =>
                                                                l.id ===
                                                                value.id
                                                        );
                                                    const index =
                                                        indexOfDefaultValue ===
                                                        -1
                                                            ? 0
                                                            : indexOfDefaultValue;
                                                    return (
                                                        <Dropdown
                                                            items={
                                                                list_status_types
                                                            }
                                                            value={list_status_types.at(
                                                                index
                                                            )}
                                                            onChange={(
                                                                _,
                                                                i
                                                            ) => {
                                                                return onChange(
                                                                    i.value
                                                                );
                                                            }}
                                                            ref={ref}
                                                            name={name}
                                                            checkable
                                                            fluid
                                                        />
                                                    );
                                                }}
                                            />
                                        )}
                                    </div>
                                </Flex>
                            </Flex>
                        </Flex>
                        {/* date a partir de  */}
                        <Flex column>
                            <div>
                                <Controller
                                    name="change_date"
                                    control={control}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "Ce champ est obligatoire",
                                        },
                                        validate: (value) => {
                                            const selectedDate = new Date(
                                                value
                                            );
                                            const today = new Date();
                                            today.setHours(0, 0, 0, 0); // Réinitialiser l'heure pour comparer uniquement la date

                                            return (
                                                selectedDate > today ||
                                                "La date doit être ultérieure à aujourd'hui"
                                            );
                                        },
                                    }}
                                    render={({
                                        field: { onChange, value, name, ref },
                                    }) => {
                                        return (
                                            <Input
                                                label="À partir de"
                                                type="date"
                                                onChange={(_, i) => {
                                                    return onChange(i.value);
                                                }}
                                                min={minToday}
                                                name={name}
                                                ref={ref}
                                                required
                                                error={errors.change_date}
                                            />
                                        );
                                    }}
                                />
                            </div>
                            {errors.change_date && (
                                <ErrorMessage
                                    content={errors.change_date.message}
                                />
                            )}
                        </Flex>
                    </>
                )}
            </Flex>
            {/* message information */}
            {show_section_attribution && (
                <Alert
                    content={
                        <Flex column gap="gap.small">
                            <Text
                                content={alert_message?.alert?.header}
                                weight="semibold"
                            />
                            <ul style={{ listStyle: "inside" }}>
                                {alert_message?.alert?.list?.map(
                                    (li, index) => (
                                        <li key={index}>
                                            <Text
                                                content={li}
                                                weight="semibold"
                                            />
                                        </li>
                                    )
                                )}
                            </ul>
                        </Flex>
                    }
                    visible={true}
                    icon={
                        <ExclamationCircleIcon styles={{ marginTop: "5px" }} />
                    }
                    styles={{
                        justifyContent: "start",
                        alignItems: "start",
                    }}
                />
            )}
        </Flex>
    );
};

export default DialogPrepareOffboardingContent;
